import * as React from 'react'

function SvgFrequencyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M45.11 7H13.667a2 2 0 00-2 2v19m-.777 21h31.444a2 2 0 002-2V25.667M11.666 28L21 21m-9.334 7l-9.333-7m42 4.667l9.333 7m-9.333-7l-9.333 7"
        stroke="currentColor"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export default SvgFrequencyIcon
